import React from 'react';
import { WebsiteDesignProps } from './types';
import { Feather, Globe2, Music2 } from 'lucide-react';
import { Button } from "@/components/ui/button";

const LiberalArts: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Humanities College";

    return (
        <div className="bg-stone-50 min-h-screen font-serif text-stone-800">
            <nav className="p-8 flex justify-center border-b border-stone-200">
                <div className="text-2xl font-bold italic text-stone-900 tracking-wide">
                    {schoolName}
                </div>
            </nav>

            <header className="py-24 px-8 text-center max-w-4xl mx-auto">
                <h1 className="text-5xl md:text-7xl mb-8 font-medium leading-tight">
                    Critical Thinking <br/> & <span className="italic text-stone-500">Creative</span> Expression.
                </h1>
                <p className="text-xl text-stone-600 mb-12 leading-relaxed">
                    We foster a diverse community of thinkers who explore the human experience through literature, history, philosophy, and the arts.
                </p>
                <div className="flex justify-center gap-6">
                    <Button variant="default" className="bg-stone-800 text-white hover:bg-stone-700 rounded-full px-10 py-6">
                        Explore Majors
                    </Button>
                </div>
            </header>

            <section className="bg-white py-20">
                <div className="container mx-auto px-8">
                    <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-stone-200">
                        <div className="p-8 text-center">
                            <Feather className="mx-auto mb-4 text-stone-400" size={32} />
                            <h3 className="text-lg font-bold mb-3 uppercase tracking-widest text-stone-900">Literature</h3>
                            <p className="text-stone-500 leading-relaxed italic">"Words are the voice of the heart."</p>
                        </div>
                        <div className="p-8 text-center">
                            <Globe2 className="mx-auto mb-4 text-stone-400" size={32} />
                            <h3 className="text-lg font-bold mb-3 uppercase tracking-widest text-stone-900">Sociology</h3>
                            <p className="text-stone-500 leading-relaxed italic">"Understanding the web of life."</p>
                        </div>
                        <div className="p-8 text-center">
                            <Music2 className="mx-auto mb-4 text-stone-400" size={32} />
                            <h3 className="text-lg font-bold mb-3 uppercase tracking-widest text-stone-900">Fine Arts</h3>
                            <p className="text-stone-500 leading-relaxed italic">"Beauty as a path to truth."</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default LiberalArts;
